import { useTranslation } from 'react-i18next';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';

import Copy from '~/components/Copy';
import useResponsive from '~/hooks/useResponsive';
import ResponsiveActionCard from '~/Nova/scenes/Site/components/ResponsiveActionCard';

import { SaveApiKeyViewProps } from '../../utils/types';
import ModalHeader from './ModalHeader';

const SaveApiKeyView = ({ apiKey, onDone, onClose }: SaveApiKeyViewProps) => {
  const { t } = useTranslation('aiTooling', {
    keyPrefix: 'apiKeys.modal.save',
  });
  const { isMobile } = useResponsive();
  const isMobileView = isMobile();

  return (
    <>
      <ModalHeader title={t('title')} onClose={onClose} />
      <DialogContent>
        <Stack spacing={4} sx={{ pt: 2 }}>
          <Alert
            severity="warning"
            data-testid="save-api-key-warning"
            sx={{ p: 0 }}
          >
            {t('warning')}
          </Alert>

          <ResponsiveActionCard
            title={t('keyLabel')}
            dataTestId="save-key-card"
          >
            <Stack
              direction={isMobileView ? 'column' : 'row'}
              spacing={1}
              alignItems="center"
            >
              <Stack
                sx={{
                  flex: 1,
                  minWidth: 0,
                  backgroundColor: 'grey.50',
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  p: 1.5,
                  fontSize: 13,
                  wordBreak: 'break-all',
                }}
                className="fs-exclude"
                data-testid="save-api-key-value"
              >
                {apiKey}
              </Stack>
              <Copy
                copyValue={apiKey}
                variant="outlined"
                color="primary"
                fullWidth={isMobileView}
                dataTestId="save-api-key-copy-btn"
                stackProps={{
                  sx: { flexShrink: 0, width: isMobileView ? '100%' : 'auto' },
                }}
              />
            </Stack>
          </ResponsiveActionCard>

          <Button
            variant="contained"
            onClick={onDone}
            data-testid="save-api-key-done-btn"
            fullWidth={isMobileView}
            sx={isMobileView ? undefined : { alignSelf: 'flex-end' }}
          >
            {t('done')}
          </Button>
        </Stack>
      </DialogContent>
    </>
  );
};

export default SaveApiKeyView;
